/**
 * pmo #23486 — ¿este rol puede usar el asistente del agente?
 *
 * El API de `agent-assistant` (`/chat`, `/tools` y `/memories`) deja pasar SOLO a estos cuatro roles (`@Roles` del controlador; las tres rutas llevan la misma
 * lista). Antes el layout montaba el panel para TODOS: a PROJECT_DEVELOPER_ADMIN, ACCOUNTING_TEAM, OPERATIONAL_TEAM, CONDOMINIUM_ADMIN, LEGAL_MODULE y
 * BUYER_CLIENT les aparecía el botón «Abrir asistente» y, al abrirlo, `GET /agent-assistant/memories` daba 403 que el hook se tragaba en silencio
 * («memorias no son críticas»): el panel decía «0 memorias activas» como si hubiera consultado y no tuviera nada.
 *
 * La lista está aquí, y NO se infiere de otro lado: `puede-usar-asistente.23486.test.ts` lee el controlador del API y falla si las dos divergen. Quitar o
 * sumar un rol en uno sin el otro pone la prueba en rojo.
 */
export const ROLES_DEL_ASISTENTE = ['AGENCY_AGENT_USER', 'AGENCY_ADMIN', 'BROKER_MANAGER_ADMIN', 'SUPER_ADMIN'] as const;

export const puedeUsarAsistente = (role?: string | null): boolean =>
  typeof role === 'string' && (ROLES_DEL_ASISTENTE as readonly string[]).includes(role);
